<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="valeurTotaleEstimee?.valeur"
    [label]="'Valeur totale estimée (HT) '" [type]="'number'" [rule]="'digits_2'" [name]="getUid()+'_SepAtt_valeur'">
</app-form-input>

    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="valeurTotaleEstimee?.devise" [label]="'Monnaie'"
    [type]="'autocomplete'" 
    [autoCompleteType]="'DEVISE'"
    [autoCompleteTypeIndex]="0"
    [rule]="'pattern_13'"
    [errorMessage]="{}" [name]="getUid()+'_SepAtt_devise'">
</app-form-input>
